<template>
  <span :class="getLoaderClass">
    <CustomIcon v-if="icon" :name="icon" />
    <span class="loader-spinner || animate-spin"></span>
  </span>
</template>

<script>
import classnames from "classnames";
import CustomIcon from "./CustomIcon.vue";

export default {
  name: "loading-indicator",
  components: { CustomIcon },
  props: {
    size: String,
    icon: String,
    hidden: Boolean,
    className: String,
  },
  computed: {
    getLoaderClass() {
      const loaderClass = classnames("loader", {
        "is-hidden": this.hidden,
        [this.size]: this.size,
        [this.className]: this.className,
      });
      return loaderClass;
    },
  },
};
</script>
